import { z } from 'zod'

export const s3ObjectResourceTypeSchema = z.enum([
  'millsheets',
  'millsheetAttachments',
  'shearingCertificates',
  'nestingDiagrams',
  'orderPdfs',
])
export type S3ObjectResourceType = z.infer<typeof s3ObjectResourceTypeSchema>

export const s3ObjectResourceTypeLabels: Record<S3ObjectResourceType, string> = {
  millsheets: 'ミルシートPDF',
  millsheetAttachments: '添付資料',
  shearingCertificates: '剪断証明書PDF',
  nestingDiagrams: 'ネスティング図PDF',
  orderPdfs: '発注書PDF',
}

export const s3ObjectResourceTypeOptions = Object.entries(s3ObjectResourceTypeLabels).map(([key, label]) => ({
  value: key as S3ObjectResourceType,
  label,
}))
